/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Tree(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M128.02637,187.875c-.02246-.01562-.03028-.01562-.05274,0A72.19779,72.19779,0,0,1,120,192.49219V232a8,8,0,0,0,16,0V192.4917a72.33623,72.33623,0,0,1-7.97266-4.6167Z" />
        <Path d="M198.10059,62.5957a76.0256,76.0256,0,0,0-140.1958-.002A72.26145,72.26145,0,0,0,16,127.7998c-.10547,38.81739,31.36035,71.19629,70.14453,72.17676A71.65658,71.65658,0,0,0,120,192.49219V156.94434L76.42236,135.15527a7.99984,7.99984,0,1,1,7.15528-14.31054L120,139.05566V88a8,8,0,0,1,16,0v27.05566l36.42236-18.21093a7.99984,7.99984,0,1,1,7.15528,14.31054L136,132.94434V192.4917A71.52878,71.52878,0,0,0,167.99707,200q.92871,0,1.86035-.02344c38.78418-.98144,70.25-33.36133,70.14258-72.18066A72.26158,72.26158,0,0,0,198.10059,62.5957Z" />
      </G>
    </Svg>
  );
}

export default Tree;
